<template>
    <div class="window-wrapper window-save-contacts dev_ok_window">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">{{text}}</div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SaveWindow",
        props: ["text"],
        methods: {
            closeWindow() {
                $('.window-save-contacts').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>